<template>

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

            <ButtonsIcon 
                icon="mdi-pencil-outline"
                color="blue accent-4"
                small
                @clicked="emit('clicked', $event)"
                v-bind="attrs"
                v-on="on"
            />

        </template>

        <span>Editar</span>

    </v-tooltip>
</template>

<script setup>

import { defineEmits } from 'vue';

const emit = defineEmits(['clicked'])

</script>